const MaintenanceBanner = () => {
  return (
    <div className="row" style={{ marginTop: "-20px", width: "100%" }}>
      <div className="col-md-12">
        <style>{`.banner { 
          background - color: #995500;
        color: #fff;
        padding: 10px;
        text-align: center;
        font-weight: bold;
            }
          `}</style>
        <div className="banner">
          LEAP will be unavailable on the 23rd to 28th April due to essential
          maintenance. We apologise for any inconvenience.
        </div>
      </div>
    </div>
  );
};

const SlimEpaHeader = () => {
  return (
    <header className="header" aria-label="Site header">
      <nav
        className="navbar-expand-xl container-fluid container-t4-xl"
        aria-label="Header navigation"
        style={{ marginTop: "20px" }}
      >
        <MaintenanceBanner />
        <div className="header__container">
          <a href="https://www.epa.ie/" className="navbar-logo">
            <img
              src="https://www.epa.ie/media/epa-2020/site-assets/images/logo/epawebnew.svg"
              alt="Environmental Protection Agency Logo"
            />
          </a>
        </div>
      </nav>
    </header>
  );
};

export { SlimEpaHeader };
